import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: {
    sectionIndex: '',
    columnIndex: '',
    name: '',
    description: '',
  },
  openForm: false,
  error: null,
  status: null,
}

const slice = createSlice({
  name: 'dynamicTableUpdateColumn',
  initialState,
  reducers: {
    changeName: (state, action) => {
      state.data.name = action.payload.name
    },
    changeDescription: (state, action) => {
      state.data.description = action.payload.description
    },
    openForm: (state, action) => {
      state.data.sectionIndex = action.payload.sectionIndex
      state.data.columnIndex = action.payload.columnIndex
      state.data.name = action.payload.name
      state.data.description = action.payload.description
      state.openForm = true
    },
    closeForm: () => initialState,
    resetForm: () => initialState,
    changeRequestStatus: (state, action) => {
      state.status = action.payload.status
    },
  },
})

const selectSlice = (state) => state.dynamicTableUpdateColumn
export const selectFormData = (state) => selectSlice(state).data
export const selectError = (state) => selectSlice(state).error
export const selectRequestStatus = (state) => selectSlice(state).status
export const selectOpenForm = (state) => selectSlice(state).openForm

const { reducer, actions } = slice

export const { changeRequestStatus, resetForm, changeDescription, changeName, openForm, closeForm } = actions

export default reducer
